import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, restaurantSession } from "@/lib/api";

export default function KDS() {
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);
  const session = restaurantSession.get();

  useEffect(() => {
    if (!session) {
      nav("/restaurant/login");
      return;
    }
    const load = () => api.get("/restaurant/orders").then((r) => {
      setOrders(r.data.filter((o) => ["new", "preparing"].includes(o.status)));
    });
    load();
    const t = setInterval(load, 3500);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, []);

  const done = async (o) => {
    await api.patch(`/restaurant/orders/${o.id}`, { status: "ready" });
    setOrders((x) => x.filter((y) => y.id !== o.id));
  };

  return (
    <div className="kds-scope min-h-screen p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="font-heading font-bold text-2xl">
          <span className="text-brand-light">tab</span>
          <span className="text-brand-orange">dine</span>
          <span className="text-xs uppercase tracking-widest text-brand-light/50 ml-3">Kitchen Display</span>
        </div>
        <button
          onClick={() => nav("/restaurant/dashboard")}
          className="text-xs text-brand-light/60 hover:text-brand-light"
          data-testid="kds-exit"
        >
          Exit KDS ×
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {orders.length === 0 && <div className="text-brand-light/50 col-span-full text-center py-16">All caught up. Nice work.</div>}
        {orders.map((o) => {
          const mins = Math.floor((Date.now() - new Date(o.created_at).getTime()) / 60000);
          return (
            <div key={o.id} className="kds-card rounded-lg p-4" data-testid={`kds-${o.id}`}>
              <div className="flex justify-between items-baseline">
                <div className="font-heading font-bold text-3xl">
                  {o.table_number ? `T${o.table_number}` : "TA"}
                </div>
                <div className="text-xs text-brand-light/60">{o.kot_number}</div>
              </div>
              <div className="text-xs text-brand-light/60 mt-1">
                {mins < 1 ? "just now" : `${mins} min`}
                {" · "}
                <span className="uppercase">{o.status}</span>
                {" · "}
                <span className="uppercase text-brand-orange">{o.order_type === "takeaway" ? "TAKEAWAY" : "DINE-IN"}</span>
              </div>
              <div className="mt-3 space-y-1">
                {o.items.map((it, i) => (
                  <div key={i} className="text-lg leading-tight">
                    <span className="text-brand-orange font-bold">{it.quantity}×</span> {it.item_name}
                    {it.special_note && (
                      <div className="text-sm text-amber-300 ml-6">↳ {it.special_note}</div>
                    )}
                  </div>
                ))}
              </div>
              {o.special_instructions && (
                <div className="mt-3 p-2 rounded bg-amber-500/20 text-amber-200 text-sm">
                  {o.special_instructions}
                </div>
              )}
              <button
                onClick={() => done(o)}
                data-testid={`kds-done-${o.id}`}
                className="mt-4 w-full py-3 rounded bg-green-600 hover:bg-green-500 text-white font-heading font-bold text-lg"
              >
                DONE ✓
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
